import * as Label from "@radix-ui/react-label";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { cn } from "../../lib/utils";

export function Field({
  children,
  className,
  description,
  error,
  htmlFor,
  label,
  required = false,
}: {
  children: ReactNode;
  className?: string;
  description?: ReactNode;
  error?: ReactNode;
  htmlFor?: string;
  label?: ReactNode;
  required?: boolean;
}) {
  return (
    <div className={cn("space-y-2", className)}>
      {label ? (
        <Label.Root
          className="flex items-center gap-1 text-sm font-semibold text-foreground"
          htmlFor={htmlFor}
        >
          <span>{label}</span>
          {required ? <span className="text-destructive">*</span> : null}
        </Label.Root>
      ) : null}
      {children}
      {description ? (
        <p className="text-sm leading-6 text-muted-foreground">{description}</p>
      ) : null}
      {error ? (
        <p className="text-sm font-medium text-destructive" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export function FieldShell({
  className,
  hasError = false,
  ...props
}: ComponentPropsWithoutRef<"div"> & {
  hasError?: boolean;
}) {
  return (
    <div
      className={cn(
        "field-shell flex min-h-11 items-center gap-3 px-4",
        hasError && "border-destructive ring-2 ring-destructive/10",
        className,
      )}
      {...props}
    />
  );
}
